import { SxProps, Theme } from '@mui/material';

export const cardSx: SxProps<Theme> = {
  mb: 2,
  backgroundColor: '#1a1a1a',
  border: '1px solid #333'
};

export const headerSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  backgroundColor: '#464545',
  color: 'white',
  p: 2,
  borderRadius: '8px 8px 0 0'
};

export const headerLeftSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 1
};

export const addButtonSx: SxProps<Theme> = {
  color: 'white',
  borderColor: 'white',
  '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' }
};

export const cardContentSx: SxProps<Theme> = {
  backgroundColor: '#161616',
  color: 'white',
  maxHeight: '400px',
  overflow: 'hidden',
  p: 0
};

export const messageBoxSuccessSx: SxProps<Theme> = {
  mb: 2,
  backgroundColor: '#1e293b',
  borderRadius: 1,
  p: 2,
  color: '#22c55e'
};

export const messageBoxErrorSx: SxProps<Theme> = {
  mb: 2,
  backgroundColor: '#1e293b',
  borderRadius: 1,
  p: 2,
  color: '#ef4444'
};

export const addCommentBoxSx: SxProps<Theme> = {
  mb: 3,
  p: 2,
  borderBottom: '1px solid #666'
};

export const textFieldSx: SxProps<Theme> = {
  mb: 2,
  '& .MuiOutlinedInput-root': {
    color: 'white',
    '& fieldset': { borderColor: '#666' },
    '&:hover fieldset': { borderColor: '#999' },
    '&.Mui-focused fieldset': { borderColor: '#0891b2' }
  }
};

export const addCommentActionsSx: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 1
};

export const cancelButtonSx: SxProps<Theme> = {
  color: 'white',
  borderColor: 'white'
};

export const addCommentButtonSx: SxProps<Theme> = {
  backgroundColor: '#0891b2'
};

export const listSx = (isAdding: boolean): SxProps<Theme> => ({
  p: 0,
  maxHeight: isAdding ? 'calc(400px - 180px)' : '400px',
  overflowY: 'auto',
  '&::-webkit-scrollbar': {
    width: '8px'
  },
  '&::-webkit-scrollbar-track': {
    background: '#1a1a1a'
  },
  '&::-webkit-scrollbar-thumb': {
    background: '#666',
    borderRadius: '4px'
  },
  '&::-webkit-scrollbar-thumb:hover': {
    background: '#888'
  }
});

export const listItemSx: SxProps<Theme> = {
  px: 2,
  py: 1.5,
  alignItems: 'flex-start'
};

export const avatarSx = (authorType: string): SxProps<Theme> => ({
  mr: 2,
  mt: 0.5,
  width: 32,
  height: 32,
  backgroundColor: authorType === 'OPERATOR' ? '#7c3aed' : '#3b82f6'
});

export const commentPrimarySx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  mb: 0.5
};

export const commentSecondarySx: SxProps<Theme> = {
  color: 'rgba(255,255,255,0.8)'
};

export const dividerSx: SxProps<Theme> = {
  backgroundColor: '#444'
};

export const noCommentsBoxSx: SxProps<Theme> = {
  textAlign: 'center',
  py:4}